
import { Component, Vue, Prop } from 'vue-property-decorator';

import Modal from '@/globalComponents/Modal/Modal.vue';

import ActiveModal from '@/share/Util/ActiveModal';

const ID_ERROR = 'error';

@Component({
  components: {
    Modal
  }
})
export default class ModalReportProblemFeedback extends Vue {
  @Prop() isSuccessful!: boolean;

  private modalInstance = new ActiveModal();

  private data = {
    success: {
      id: 'success',
      src: 'woohooo.svg',
      alt: 'Woohooo',
      description: 'buttonReportProblemComponents.modalReportProblemFeedback.success.description', 
      textButton: 'buttonReportProblemComponents.modalReportProblemFeedback.success.textButton'
    },
    error: {
      id: 'error',
      src: 'Ooops.svg',
      alt: 'Ooops',
      description: 'buttonReportProblemComponents.modalReportProblemFeedback.error.description', 
      textButton: 'buttonReportProblemComponents.modalReportProblemFeedback.error.textButton'
    }
  };

  get infoModal() {
    if (this.isSuccessful) return this.data.success;

    return this.data.error;
  }

  handleClick() {
    if (this.infoModal.id !== ID_ERROR) return;

    this.modalInstance.activeModal('modalReportProblem');
  }
}
